import { redirect } from '@tanstack/react-router';

import { getRuntimeConfig } from '@/lib/runtime-config.js';

/**
 * Route guard: if an admin has disabled the Decks section (runtime config
 * `features.decks === false`), redirect away from any `/decks*` route
 * (covers deep-links / bookmarks, not just the hidden nav entry).
 *
 * Fail-open — the config loader defaults the flag to `true`, so a config blip
 * leaves the route accessible (the gate is cosmetic; real auth stays server-side).
 */
export function ensureDecksEnabled(): void {
  if (!getRuntimeConfig().features.decks) {
    throw redirect({ to: '/' });
  }
}
